import { NavConfigItem } from "Navigation";

export class SubRoutes {
  [x: string]: SubRouteConfig;
}

export type FunctionalComponent = React.FC<any>;

export class SubRouteConfig {
  constructor(
    route: string,
    label: string,
    component: FunctionalComponent,
    icon?: any,
    isDefault = false,
    permissions?: number[],
    hideInSidebar = false,
    routeProps = {},
    showInDropdown = false,
    path = route,
  ) {
    this.route = route;
    this.label = label;
    this.component = component;
    this.icon = icon;
    this.default = isDefault;
    this.permissions = permissions;
    this.hideInSidebar = hideInSidebar;
    this.routeProps = routeProps;
    this.showInDropdown = showInDropdown;
    this.path = path;
  }

  label: string;
  icon?: any;
  route: string;
  component: FunctionalComponent;
  default: boolean;
  hideInSidebar: boolean;
  permissions?: number[];
  routeProps?: any;
  showInDropdown?: boolean;
  path: string;
}

export class DropdownSubRouteConfig extends SubRouteConfig {
  constructor(
    route: string,
    label: string,
    component: FunctionalComponent,
    permissions?: number[],
    isDefault = false,
    routeProps = {},
  ) {
    super(
      route,
      label,
      component,
      undefined,
      isDefault,
      permissions,
      false,
      routeProps,
      true,
      undefined,
    );
  }
}

export class AdminSubRouteConfig extends SubRouteConfig {
  constructor(
    route: string,
    label: string,
    component: FunctionalComponent,
    isDefault = false,
    permissions?: number[],
    hideInSidebar = false,
    routeProps = {}
  ) {
    super(
      route,
      label,
      component,
      undefined,
      isDefault,
      permissions,
      hideInSidebar,
      routeProps
    );
  }
}

export type SubNavConfigMap = {
  [x: string]: NavConfigItem[];
};
